// localStorage throws where the browser blocks it, e.g. in a third-party
// iframe (itch.io) with third-party cookies off. Reads then act as if
// nothing was saved, and writes are dropped.

export const readStorage = (key) => {
    try {
        return localStorage.getItem(key)
    } catch {
        return null
    }
}

export const writeStorage = (key, value) => {
    try {
        localStorage.setItem(key, value)
    } catch {
        // Nowhere to save it
    }
}
